export enum QueryKey {
  submitAccountVerification = 'submitAccountVerification',
  updatePayout = 'updatePayout',
}
